/** Shown in the assistant bubble while the chat API request is in flight. */
export const ASSISTANT_PENDING_TEXT = 'Thinking…'

export function isPendingAssistantText(text) {
  return text === ASSISTANT_PENDING_TEXT
}
